import React, { Component } from 'react'
import Select from 'react-select'

class Gender extends Component {
    constructor() {
        super()
        this.state = {
            GenderList:[ {"label":"Male","value":"Male"},{"label":"Female","value":"Female"},{"label":"Transgender","value":"Transgender"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.GenderList}
                placeholder="Select Gender"
                onChange={(e) => { (e) ? this.props.genderChange(e) : this.props.genderChange([])}}
                />
            </div>
        )
    }
}

export default Gender


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/Gender.js